<template>
  <div>
    <el-dialog title="发货信息" :visible.sync="dialogVisible" @close="onCancel">
      <el-form label-width="150px" label-position="right" :model="localDataForm" ref="ruleForm" :rules="rules">
        <el-row>
          <el-col :span="11">
            <el-form-item label="物流公司" prop="logisticsCompany">
              <el-select v-model="localDataForm.logisticsCompany" filterable placeholder="请选择物流公司" clearable>
                <el-option v-for="item in logisticsCompanyArr" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="物流单号" prop="logisticsNo">
              <el-input v-model.trim="localDataForm.logisticsNo" placeholder="请输入物流单号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" plain @click="onCancel">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>
export default {
  props: {
    // 接受父级组件的显示标记，用于被watch
    showFlag: {
      type: Boolean
    },
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 物流公司
      logisticsCompanyArr: [
        {
          value: '邮政快递',
          label: '邮政快递'
        }, {
          value: '韵达快递',
          label: '韵达快递'
        }, {
          value: '顺丰快递',
          label: '顺丰快递'
        }, {
          value: '中通快递',
          label: '中通快递'
        }, {
          value: '圆通快递',
          label: '圆通快递'
        }, {
          value: '京东快递',
          label: '京东快递'
        }, {
          value: '百世快递',
          label: '百世快递'
        }, {
          value: '极兔快递',
          label: '极兔快递'
        }, {
          value: '申通快递',
          label: '申通快递'
        }, {
          value: '德邦快递',
          label: '德邦快递'
        },
      ],
      //  prop 值的局部数据属性  
      localDataForm: this.ruleForm,
      rules: {
        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' },
        ],
        logisticsNo: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
          // 添加通用快递单号校验规则
          {
            validator: this.validateExpressNumber,
            trigger: 'change'
          }
        ],
      },
    }
  },
  watch: {
    // 观察父级组件的传值
    showFlag(newVal) {
      this.dialogVisible = newVal
    },
  },
  created() {

  },
  methods: {
    // 弹窗输入(优化)
    async submitForm(formName) {
      try {
        // 校验表单 
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              reject(new Error('表单校验失败')); // 拒绝Promise并传递错误  
            } else {
              resolve(); // 校验成功，解决Promise  
            }
          });
        });
        // 准备要发送的数据  
        const data = {
          orderId: this.ruleForm.orderId,
          logisticsCompany: this.localDataForm.logisticsCompany,//物流公司
          logisticsNo: this.localDataForm.logisticsNo,//物流单号
        };
        // console.log('准备要发送的数据 ', data);
        let response = await this.$axios.post(this.$api.productOrderDeliver, data);
        // 处理响应结果
        const { code } = response;
        if (code == 100) {
          this.$message({ message: '恭喜你，发货成功!', type: 'success' });
          this.onCancel();//重置+关闭弹窗 
        }

      } catch (error) {
        console.log(error);
      }
    },
    // 快递单号校验
    validateExpressNumber(rule, value, callback) {
      // 判断是否只包含数字和字母
      if (!/^[a-zA-Z0-9]+$/.test(value)) {
        callback(new Error('物流单号只能包含数字和字母'));
        return;
      }

      // 判断长度是否在常见的合理范围（10 - 18位）
      if (value.length < 10 || value.length > 18) {
        callback(new Error('物流单号长度应在10 - 18位之间'));
        return;
      }

      callback();
    },
    // 检验重置
    resetForm() {
      this.localDataForm = {};//清空对象
      this.$refs.ruleForm.resetFields();
    },

    // 触发父级组件的closeChildDialog
    onCancel() {
      this.resetForm()//重置校验
      this.$emit('closeChildDialog')
    },
  },
}
</script>

<style scoped lang='scss'>
// 图片
.logo_pic {
  position: relative;

  ::v-deep .el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .pic-row {
    display: flex;

    .pic {
      margin-right: 15px;

      .logo_uploader {
        ::v-deep .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        ::v-deep .el-upload:hover {
          border-color: #069bbc;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #069bbc;
          width: 100px;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }

        .logoimg {
          width: 100px;
          height: 100px;
          display: block;
          object-fit: cover;
        }
      }
    }
  }

  .delpic {
    position: absolute;
    top: -12px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic1 {
    right: -15px;
  }

  .delpic2 {
    right: -134px;
  }

  .delpic3 {
    right: -250px;
  }
}
</style>
